/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Header, AppCardListComp } from '../components';
import {
  useSMAddCreditUnion,
  useSMCreditUnionDetailGetContent,
} from '../machines';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { SupplyChainListPageService } from '../services';
import { VApplication } from '@/application';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { SearchFilter } from '@widgets/filter-widget-react';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.SupplyChainListPageService'
  ) as SupplyChainListPageService;
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const srv = getSrv();

  useEffect(() => {
    srv?.resetCriteria();
  }, []);

  const {
    credituniondetailPageMachine,
    credituniondetailPageState,
    credituniondetailPageSend,
  } = useSMCreditUnionDetailGetContent({});

  const { addCreditUnionMachine, addCreditUnionSend, addCreditUnionState } =
    useSMAddCreditUnion({});

  const onHeaderAction1Click = () => {
    if (!showModal) {
      setShowModal(true);
    }
  };

  const onError = () => {
    // window.location.reload(false);
  };

  const onPageChange = (page: number) => {
    console.log(`page change`, page);

    credituniondetailPageSend('TRIGGER_REFRESH', {
      offset: (page - 1) * 10,
      size: 10,
    });
  };

  const onRefresh = () => {
    credituniondetailPageSend('TRIGGER_REFRESH', {});
    setRefreshPagination(new Date());
  };

  const onClearFilter = () => {
    srv?.resetCriteria();
    credituniondetailPageSend('TRIGGER_REFRESH', {});
  };

  const _renderNotifications = () => {
    if (addCreditUnionState?.matches('ADD_CREDIT_UNION_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications.addGroupSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    return null;
  };

  const onPaginationChange = (event: any) => {
    credituniondetailPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const onApplyFilter = (data: any) => {
    console.log('on applyfilter', data);
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    credituniondetailPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const addNewCreditUnion = (data: any) => {
    console.log(`profile data`, data);
    if (showModal) {
      setShowModal(false);
    }
    addCreditUnionSend('START', {
      payload: data,
    });
  };
  const _renderPagination = () => {
    return (
      <Paginate
        {...(credituniondetailPageState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        key={refreshPagination}
        totalItems={
          credituniondetailPageState?.event?.data?.value?.appCardList?.length
        }
      />
    );
  };

  const _renderPage = () => {
    if (addCreditUnionState?.matches('ADD_CREDIT_UNION')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingAddGroup || {})}
        />
      );
    }

    if (credituniondetailPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          {/* <AppCardListComp
            {...(credituniondetailPageState?.event?.data?.value || {})}
            onCardClick={props?.onCardClick}
            onPageChange={onPageChange}
          /> */}
          {credituniondetailPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <AppCardListComp
              {...(credituniondetailPageState?.event?.data?.value || {})}
              onCardClick={props?.onCardClick}
              onPageChange={onPageChange}
            />
          )}
        </>
      );
    }
    if (credituniondetailPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingHolderGroup || {})}
        />
      );
    }

    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderAction1Click={onHeaderAction1Click}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  const _renderSearch = () => {
    return (
      <SearchFilter
        {...(staticPageContentConfig?.settings || {})}
        onFilterApply={onApplyFilter}
        onClearFilter={onClearFilter}
      />
      // <SettingsComp
      // {...staticPageContentConfig?.settings}
      // onApplyFilter={onApplyFilter}
      // onClearFilter={onClearFilter} />
    );
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        <TweetyModal
          show={true}
          size={'lg'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Add Supplier'}
          onSubmit={addNewCreditUnion}
          onHide={() => setShowModal(false)}
          title={'Add New Supplier'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.addGroup?.FIELDS,
            layout: staticPageContentConfig?.addGroup?.layout,
          }}
        />
      );
    }
  };
  const _renderErrorModals = () => {
    if (addCreditUnionState?.matches('ADD_CREDIT_UNION_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.addGroup || {})}
          description={[
            addCreditUnionState?.event?.data?.value,
            staticPageContentConfig?.error?.addGroup?.description[1],
          ]}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
    if (credituniondetailPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getGroup || {})}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
  };
  return (
    <>
      {_renderHeader()}
      {_renderSearch()}
      {_renderPage()}
      {_renderErrorModals()}
      {_renderPagination()}
      {_renderModal()}
      {_renderNotifications()}
    </>
  );
};
